import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useVendor } from '../context/VendorContext';
import './Sidebar.css';

const Sidebar = ({ user, onShowAuthModal, collapsed, onToggle, conversations = [], activeConversationId, onFeedbackOpen }) => {
  const navigate = useNavigate();
  const { features } = useVendor();
  const [showHistory, setShowHistory] = useState(false);

  const menuItems = [
    { label: 'Home', path: '/', icon: '/icons/home.svg' },
    features.vault && { label: 'My Vault', path: '/vault', icon: '/icons/vault.svg' },
    features.explore && { label: 'Explore', path: '/explore', icon: '/icons/explore.svg' },
  ].filter(Boolean);

  return (
    <>
      <aside className={`v2-sidebar ${collapsed ? 'collapsed' : ''}`}>
        {/* Toggle button - aligned right */}
        <div className="sidebar-header">
          <button
            className="sidebar-toggle"
            onClick={onToggle}
            title={collapsed ? 'Expand menu' : 'Collapse menu'}
          >
            <img src="/icons/menu-toggle.svg" alt="" className="toggle-icon" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              end={item.path === '/'}
            >
              <span className="sidebar-nav-icon"><img src={item.icon} alt="" /></span>
              <span className="sidebar-nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Chat History Section - only if chat feature is enabled */}
        {user && features.chat && (
          <div className="sidebar-chat-history">
            <button
              className="sidebar-new-chat-btn"
              onClick={() => navigate('/chat')}
              title="New Chat"
            >
              <img src="/icons/chat-new.svg" alt="" className="sidebar-new-chat-icon" />
              <span className="sidebar-new-chat-label">New Chat</span>
            </button>

            {conversations.length > 0 && (
              <>
                <button
                  className="sidebar-history-toggle"
                  onClick={() => setShowHistory(!showHistory)}
                  title={showHistory ? 'Hide chat history' : 'Show chat history'}
                >
                  <svg className="sidebar-history-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span className="sidebar-history-label">Chat History</span>
                  <svg className={`sidebar-history-chevron ${showHistory ? 'open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                {showHistory && (
                  <div className="sidebar-conversations">
                    {conversations.slice(0, 5).map(conv => (
                      <NavLink
                        key={conv.id}
                        to={`/chat/${conv.id}`}
                        className={() =>
                          `sidebar-conv-item ${activeConversationId === conv.id ? 'active' : ''}`
                        }
                        title={conv.title}
                      >
                        <span className="sidebar-conv-title">{conv.title}</span>
                      </NavLink>
                    ))}
                    <NavLink to="/history" className="sidebar-show-more-btn">
                      Show More →
                    </NavLink>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Feedback Button - only if feedback feature is enabled */}
        {features.feedback && (
          <div className="sidebar-bottom">
            <button className="sidebar-feedback-btn" onClick={onFeedbackOpen} title="Share Feedback">
              Feedback
            </button>
          </div>
        )}
      </aside>

      {/* Mobile bottom nav */}
      <nav className="v2-mobile-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            end={item.path === '/'}
          >
            <span className="mobile-nav-icon"><img src={item.icon} alt="" /></span>
            <span className="mobile-nav-label">{item.label}</span>
          </NavLink>
        ))}
        {user && features.chat && (
          <NavLink
            to="/chat"
            className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="mobile-nav-icon"><img src="/icons/chat-new.svg" alt="" /></span>
            <span className="mobile-nav-label">Chat</span>
          </NavLink>
        )}
        {features.feedback && (
          <button className="mobile-nav-item mobile-nav-feedback" onClick={onFeedbackOpen}>
            <span className="mobile-nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3F3278" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </span>
            <span className="mobile-nav-label">Feedback</span>
          </button>
        )}
      </nav>
    </>
  );
};

export default Sidebar;
